import React, { useState } from "react";
import { Button, Dropdown, message } from "antd";
import { DownloadOutlined } from "@ant-design/icons";

import { exportCrmReportApi } from "../../../apiservice/crm";

// Same blob-download pattern as the Leads list's own export (handleExport in
// pages/Crm/Leads/index.js) -- createObjectURL + a synthetic <a download>,
// with the same Blob-error-body unwrap for 413 (too many rows) / 403
// (outside the caller's report scope) responses from the server.
const ReportExportButton = ({ reportType, filters }) => {
  const [exporting, setExporting] = useState(false);

  const doExport = async (format) => {
    setExporting(true);
    try {
      const res = await exportCrmReportApi(reportType, filters, format);
      const url = window.URL.createObjectURL(res.data);
      const a = document.createElement("a");
      a.href = url;
      a.download = `${reportType}_export_${new Date().toISOString().slice(0, 10)}.${format}`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      let text = err.message;
      try {
        if (err.response instanceof Blob) text = JSON.parse(await err.response.text()).message || text;
      } catch {
        /* keep the generic message */
      }
      message.error(text || "Export failed");
    } finally {
      setExporting(false);
    }
  };

  return (
    <Dropdown
      menu={{
        items: [
          { key: "xlsx", label: "Export as Excel (.xlsx)" },
          { key: "csv", label: "Export as CSV" },
        ],
        onClick: ({ key }) => doExport(key),
      }}
    >
      <Button icon={<DownloadOutlined />} loading={exporting}>
        Export
      </Button>
    </Dropdown>
  );
};

export default ReportExportButton;
